import {
  Component,
  AfterViewInit,
  QueryList,
  ViewChildren,
  ElementRef,
  HostListener,
} from '@angular/core';
import { DeveloperTabsService, Tab } from '../../services/developer-tabs.service';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-developer-tabs-navigation',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './developer-tabs-navigation.html',
  styleUrls: ['./developer-tabs-navigation.scss'],
})
export class DeveloperTabsNavigation implements AfterViewInit {
  tabs: Tab[] = [];
  activeTab: string = '';

  @ViewChildren('tabRef') tabRefs!: QueryList<ElementRef>;

  activeTabWidth = 0;
  activeTabLeft = 0;

  constructor(private tabsService: DeveloperTabsService) {}

  ngOnInit(): void {
    this.tabs = this.tabsService.getTabs();
    this.activeTab = this.tabsService.getActiveTab();

    this.tabsService.activeTab$.subscribe((tabId) => {
      this.activeTab = tabId;
      this.updateUnderline();
    });
  }

  ngAfterViewInit(): void {
    this.updateUnderline();
    this.tabRefs.changes.subscribe(() => this.updateUnderline());
  }

  onTabClick(tabId: string): void {
    this.tabsService.setActiveTab(tabId);
    this.updateUnderline();
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateUnderline();
  }

  updateUnderline() {
    if (!this.tabRefs || this.tabRefs.length === 0) {
      return;
    }

    const activeTabEl = this.tabRefs.find((_, i) => this.tabs[i].id === this.activeTab);
    if (activeTabEl) {
      const rect = activeTabEl.nativeElement.getBoundingClientRect();
      const parentRect = activeTabEl.nativeElement.parentElement.getBoundingClientRect();
      this.activeTabWidth = rect.width;
      this.activeTabLeft = rect.left - parentRect.left;
    }
  }
}
